import { Col, Container, Row } from "reactstrap";
import { JobList, JobSearch } from "../../../../constants";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import LeftSidebar from "../common/leftSidebar";
import RightSidebarCards from "../common/rightSidebarCards";

const ListViewContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={JobList} parent={JobSearch} />
      <Container fluid>
        <Row>
          <LeftSidebar />
          <Col xl="9" className="xl-60 box-col-12">
            <RightSidebarCards startLimit={0} endLimit={8} />
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default ListViewContainer;
